<!-- <div class="order-placed-card">
  <div class="icon">
    <i class="fas fa-info-circle"></i>
  </div>
  <div class="content">
    <h3>Order Missed</h3>
    <p>This order was placed for another seller. You missed this opportunity.</p>
  </div>
</div> -->

<div class="order-missed">
  <div class="card">
    <img src="assets/order-placed.jpg" alt="Order Missed" />
    <h3>Order Placed for Another Seller</h3>
</div>